import { createStore, createEvent } from 'effector';
import { LocalStorageUtils } from '@shared/utils';

const setIsCollapsed = createEvent<boolean>();
const toggleMenuEvent = createEvent();
const clearEvent = createEvent();

const $store = createStore<boolean>(LocalStorageUtils.getMenuIsCollapsed())
  .on(setIsCollapsed, (_, data) => data)
  .on(toggleMenuEvent, (state) => !state)
  .reset(clearEvent);
$store.watch((isCollapsed) => LocalStorageUtils.setMenuIsCollapsed(isCollapsed));

export const $menuStore = {
  events: {
    setIsCollapsed: setIsCollapsed,
    toggleMenu: toggleMenuEvent,
    clear: clearEvent,
  },
  store: $store,
};
